// Run initializers
import './initializers/register-system-events';
import './initializers/initialize-window-manager';
import './initializers/initialize-lazy-loading';
import './initializers/intercept-what-input';
import './initializers/initialize-trackings';
import './initializers/app-api-callback';
import './initializers/initialize-cookie-acceptance';
import '@bonprix/pattern-library/initializers/register-window-click';

import whatInput from "what-input";

window.whatInput = whatInput;

// Global ajax request counter variable for selenium
window.ajaxRequestsPending = 0;


